// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7e705572","120":"52650370","127":"fbde2e26","227":"d8510e30","315":"99d16ff9","471":"ccbf096f","724":"b0bf7e1f","842":"12295dd8","852":"03c1931b","889":"b3e135ac","950":"d69adab2","962":"27c06368"}[chunkId] + ".chunk.js";
};